import { useEffect, useState, type FormEvent, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { CircleAlert, CircleCheck, ShieldCheck } from 'lucide-react';
import { CampoTexto } from '../ui/Campos';
import { Botao } from '../ui/Sobreposicoes';
import { codigoMfa } from './estado';
import './i18n';

export function useRelogioMfa() {
  const [agora, setAgora] = useState(Date.now);
  useEffect(() => { const intervalo = window.setInterval(() => setAgora(Date.now()), 1000); return () => window.clearInterval(intervalo); }, []);
  return agora;
}
export function MfaMensagem({ tipo, children }: { tipo: 'erro' | 'sucesso' | 'aviso'; children: ReactNode }) {
  return <div role={tipo === 'erro' ? 'alert' : 'status'} className={`flex items-start gap-3 rounded-xl border border-borda bg-sup-2 p-4 text-sm ${tipo === 'erro' ? 'text-perigo' : tipo === 'sucesso' ? 'text-sucesso' : 'text-tinta-2'}`}>
    {tipo === 'sucesso' ? <CircleCheck size={18} className="mt-0.5 shrink-0" /> : <CircleAlert size={18} className="mt-0.5 shrink-0" />}
    <div className="min-w-0 leading-relaxed">{children}</div>
  </div>;
}
export function MfaCarregando({ conta = false }: { conta?: boolean }) {
  const { t } = useTranslation('mfa');
  return <div role="status" aria-busy="true" className="space-y-4">
    <p className="text-sm text-tinta-2">{t(conta ? 'carregandoEstado' : 'carregando')}</p>
    <div aria-hidden="true" className="space-y-3 motion-safe:animate-pulse"><div className="h-4 w-3/4 rounded bg-sup-3" /><div className="h-10 rounded-lg bg-sup-3" /><div className="h-10 w-1/2 rounded-lg bg-sup-3" /></div>
  </div>;
}
export function MfaBloqueado({ ate }: { ate: string | null }) {
  const { t, i18n } = useTranslation('mfa');
  const data = ate ? new Date(ate) : null;
  const hora = data && Number.isFinite(data.getTime()) ? data.toLocaleTimeString(i18n.language === 'pt' ? 'pt-BR' : i18n.language, { hour: '2-digit', minute: '2-digit' }) : null;
  return <MfaMensagem tipo="erro"><strong className="block font-semibold">{t('bloqueado')}</strong><p className="mt-1">{hora ? t('bloqueadoTexto', { hora }) : t('bloqueadoGenerico')}</p></MfaMensagem>;
}
export function MfaFormularioCodigo({ codigo, aoMudar, aoEnviar, ocupado, desabilitado = false, rotulo = 'verificar' }: {
  codigo: string; aoMudar: (codigo: string) => void; aoEnviar: (evento: FormEvent<HTMLFormElement>) => void;
  ocupado: boolean; desabilitado?: boolean; rotulo?: string;
}) {
  const { t } = useTranslation('mfa');
  return <form onSubmit={aoEnviar} className="space-y-4" aria-busy={ocupado}>
    <CampoTexto rotulo={t('codigo')} ajuda={t('ajudaCodigo')} name="codigo" type="text" inputMode="numeric" autoComplete="one-time-code" pattern="[0-9]{6}" maxLength={6} required value={codigo} onChange={(e) => aoMudar(codigoMfa(e.target.value))} disabled={ocupado || desabilitado} />
    <Botao type="submit" disabled={ocupado || desabilitado || codigo.length !== 6} className="w-full sm:w-auto"><ShieldCheck size={17} />{t(ocupado ? 'confirmando' : rotulo)}</Botao>
  </form>;
}
